// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import routes from './router/index.js'

Vue.config.productionTip = false


import axios from 'axios'
Vue.prototype.$http = axios;

import '../src/utils/global.css' /*引入公共样式*/



import { development } from './request/http.js'
Vue.prototype.downloadUrl = development;
Vue.prototype.imageUrl_ = development + "/api/platform/common/file/url/"


// elementUi组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


// 路由组件
import VueRouter from 'vue-router'
Vue.use(VueRouter)



// 防止el-button重复点击
Vue.directive('preventReClick', {
    inserted (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 2000)
            }
        })
    }
});


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: "hash",
    routes
})


// 导航守卫
router.beforeEach(async (to, from, next) => {
    let sessionId = localStorage.getItem('Authorization') || '';
    if (sessionId) { //已登录
        next()
    } else { //未登录定向到登录页面
        if (to.path == '/login') {
            next();
        } else {
            next('/login')
        }
    }
})


router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js